define('helpers/gmaps', [
	'rjsasync!https://maps.google.com/maps/api/js?key=@@CONFIGURATION_GOOGLE_API_KEY&libraries=geometry,places'
], function () {
	'use strict';

	return window.google;
});

